import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-cross\"><path fill=\"#CE3F4F\" fill-rule=\"evenodd\" d=\"M6 1.375a4.625 4.625 0 1 0 0 9.25 4.625 4.625 0 0 0 0-9.25M.625 6a5.375 5.375 0 1 1 10.75 0A5.375 5.375 0 0 1 .625 6m3.61-1.765a.375.375 0 0 1 .53 0L6 5.47l1.235-1.235a.375.375 0 1 1 .53.53L6.53 6l1.235 1.235a.375.375 0 1 1-.53.53L6 6.53 4.765 7.765a.375.375 0 0 1-.53-.53L5.47 6 4.235 4.765a.375.375 0 0 1 0-.53\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol